import { ProtocoloMotivo } from './protocolo-motivo.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class ProtocoloMotivoService {

    constructor(private http: Http){}

    getProtocoloMotivos(): Observable<ProtocoloMotivo[]> {
        return this.http.get(`${NTECH_API}/protocolo-motivo`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }
}


// WEBPACK FOOTER //
// ./src/app/protocolo-motivo/protocolo-motivo.service.ts